export const groupBy = <T,>(array: Array<T>, predicate: (value: any, index: number, array: Array<T>) => string | number) =>
  array.reduce(
    (acc, value, index, array) => {
      (acc[predicate(value, index, array)] ||= []).push(value);
      return acc;
    },
    {} as { [key: string]: Array<T> },
  );
